import React, { Component } from 'react'
import { NoContentBox } from 'components/basic'

class Unauthorized extends Component {
  render () {
    return (
      <div className='content-wrapper flexbox-absolute-center'>
        <NoContentBox icon='eye-slash' text='You are not authorized to view this page' />
      </div>
    )
  }
}
export default Unauthorized



// WEBPACK FOOTER //
// ./src/views/core/unauthorized.js